/**
 * Created by lihanying on 2017/6/29.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import { GETCLUBPROFESSION, GETTOTALTYPE } from './constants'

export const getClubProfession = (payload) => {
  return {
    type: GETCLUBPROFESSION,
    payload,
  }
}
export const getTotalType = (payload) => {
  return {
    type: GETTOTALTYPE,
    payload,
  }
}

//业务分类列表
export function fetchClubProfession() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/ServiceApi/FirmTypeList`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubProfession(data.list))
      return data
    })
  }
}

//删除业务分类
export function fetchDeleteProfession(type_id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/ServiceApi/DeleteFirmType`
    return postData(
      endpoint,
      'POST',
      JSON.stringify({
        id: type_id,
      })
    ).then((data) => {
      if (data.status === true) {
        dispatch(fetchClubProfession())
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}

//总分类
export function fetchTotalType() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/ServiceApi/AddFirmType`
    return fetchData(endpoint).then((data) => {
      dispatch(getTotalType(data.list))
    })
  }
}

//添加业务分类
export function fetchAddFirmType(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/ServiceApi/AddFirmType`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchClubProfession())
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubProfession/action.js